import { useContext } from 'react';
import { RegistersChartsDataContext } from '../contexts/RegistersChartsDataContext';

export const useRegistersChartsDataContext = () => {
    return useContext(RegistersChartsDataContext);
};
